// 专业列表
export const professionList = [
  {
    name: '初级会计职称',
    id: '1',
  },
  {
    name: '中级会计职称',
    id: '2',
  },
];

// 课程列表
export const courseList = {
  1: [
    {
      name: '初级会计实务',
      id: '1',
    },
    {
      name: '经济法基础',
      id: '2',
    },
  ],
  2: [
    {
      name: '中级会计实务',
      id: '3',
    },
    {
      name: '经济法',
      id: '4',
    },
    {
      name: '财务管理',
      id: '5',
    },
  ],
};
